
const ErrorPage = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 text-center">
      <h1 className="text-6xl font-bold text-secondary">404</h1>
      <h2 className="text-2xl  text-tertiary">Page Not Found</h2>
      <p className="text-gray-600 mt-2">
        Sorry, the page you’re looking for doesn’t exist.
      </p>
      <a
        href="/"
        className="mt-6 px-6 py-2 bg-quaternary text-white rounded-lg shadow hover:bg-quaternary-700 transition"
      >
        Go Home
      </a>
    </div>
  );
};

export default ErrorPage;
